import { drawingActions, DrawingStore, drawingStore } from "src/js/stores/drawing";
import { mapActions, mapStore, MapStore } from "src/js/stores/map";
import { osMapPrintActions, osMapPrintStore, OsMapPrintStore } from "src/js/stores/osMapPrint";
import { siteActions, siteStore, SiteStore } from "src/js/stores/site";
import {
  siteGeometryActions,
  siteGeometryStore,
  SiteGeometryStore,
} from "src/js/stores/siteGeometry/";
import { userActions, userStore, UserStore } from "src/js/stores/user";
import { StripeStore, stripeStore } from "src/js/stores/stripe/store";
import { letterStore, LetterStore, letterActions } from "src/js/stores/letter";
import { planningStore, PlanningStore, planningActions } from "src/js/stores/planning";
import { alertsActions, AlertsStore, alertsStore } from "src/js/stores/alerts";
import { comparablesActions, ComparablesStore, comparablesStore } from "src/js/stores/comparables";
import {
  SitesPipelineStore,
  sitesPipelineStore,
} from "../../../domains/sites/pipeline/store/store";
import * as sitesPipelineStoreActions from "../../../domains/sites/pipeline/store/actions";
import { searchActions, searchStore, SearchStore } from "src/js/stores/search";

export type StoreModules = {
  [key in Stores]: StoreModule<key>;
};

type StoreModule<TKey extends Stores> = {
  state: StoreFromStores<TKey>;
  actions: ActionsFromStores<TKey>;
};

export enum Stores {
  map = "map",
  constraints = "constraints",
  drawing = "drawing",
  osMapPrint = "osMapPrint",
  site = "site",
  siteGeometry = "siteGeometry",
  sitesPipeline = "sitesPipeline",
  user = "user",
  stripe = "stripe",
  letter = "letter",
  planning = "planning",
  alerts = "alerts",
  comparables = "comparables",
  search = "search",
}

export type StoreFromStores<TKey extends Stores> = TKey extends Stores.map
  ? MapStore
  : TKey extends Stores.drawing
  ? DrawingStore
  : TKey extends Stores.osMapPrint
  ? OsMapPrintStore
  : TKey extends Stores.site
  ? SiteStore
  : TKey extends Stores.sitesPipeline
  ? SitesPipelineStore
  : TKey extends Stores.siteGeometry
  ? SiteGeometryStore
  : TKey extends Stores.stripe
  ? StripeStore
  : TKey extends Stores.letter
  ? LetterStore
  : TKey extends Stores.planning
  ? PlanningStore
  : TKey extends Stores.alerts
  ? AlertsStore
  : TKey extends Stores.search
  ? SearchStore
  : TKey extends Stores.comparables
  ? ComparablesStore
  : UserStore;

export type ActionsFromStores<TKey extends Stores> = TKey extends Stores.map
  ? typeof mapActions
  : TKey extends Stores.drawing
  ? typeof drawingActions
  : TKey extends Stores.osMapPrint
  ? typeof osMapPrintActions
  : TKey extends Stores.site
  ? typeof siteActions
  : TKey extends Stores.sitesPipeline
  ? typeof sitesPipelineStoreActions
  : TKey extends Stores.siteGeometry
  ? typeof siteGeometryActions
  : TKey extends Stores.letter
  ? typeof letterActions
  : TKey extends Stores.planning
  ? typeof planningActions
  : TKey extends Stores.alerts
  ? typeof alertsActions
  : TKey extends Stores.search
  ? typeof searchActions
  : TKey extends Stores.comparables
  ? typeof comparablesActions
  : typeof userActions;

export const stores = {
  map: {
    state: mapStore,
    actions: mapActions,
  },
  drawing: {
    state: drawingStore,
    actions: drawingActions,
  },
  osMapPrint: {
    state: osMapPrintStore,
    actions: osMapPrintActions,
  },
  site: {
    state: siteStore,
    actions: siteActions,
  },
  sitesPipeline: {
    state: sitesPipelineStore,
    actions: sitesPipelineStoreActions,
  },
  siteGeometry: {
    state: siteGeometryStore,
    actions: siteGeometryActions,
  },
  user: {
    state: userStore,
    actions: userActions,
  },
  stripe: {
    state: stripeStore,
  },
  letter: {
    state: letterStore,
    actions: letterActions,
  },
  planning: {
    state: planningStore,
    actions: planningActions,
  },
  alerts: {
    state: alertsStore,
    actions: alertsActions,
  },
  search: {
    state: searchStore,
    actions: searchActions,
  },
  comparables: {
    state: comparablesStore,
    actions: comparablesActions,
  },
} as StoreModules;
